import React, {useMemo} from 'react';
import cn from 'classnames';

import Link from 'brandComponents/Link';
import Typography from 'brandComponents/Typography';

import {IProductNameProps} from './IProductName';

import styles from './ProductName.module.scss';

// [POTENTIAL_CORE_COMPONENT] - Product name component could be used elsewhere
const ProductName = ({
	url,
	as,
	classNames,
	onClick,
	children,
}: IProductNameProps) => {
	const WrapperTag = useMemo(() => {
		if (!url && !onClick) {
			return 'div';
		}

		if (url) {
			return Link;
		}

		return 'button';
	}, [url, onClick]);

	const wrapperProps = useMemo(() => ({
		className: styles['product-media__link-image-wrapper'],
		to: url,
		type: !url ? 'button' : undefined,
		onClick: onClick,
	}), [onClick, url]);

	return (
		<div className={cn(styles['product-name'], 'product-name')}>
			<WrapperTag {...wrapperProps}>
				{/* @ts-ignore */}
				<Typography
					variant={as}
					classNames={cn(styles['product-name__content'], classNames, 'product-name__content')}
				>
					{/* @ts-ignore */}
					{children}
				</Typography>
			</WrapperTag>
		</div>
	);
};

export default ProductName;
